import { forwardRef } from "react";
import { Icon } from "./Icon";
import { slot } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
export const InnerMultiVariantIcon = ({
  forwardedRef,
  size,
  src24: Component24,
  src32: Component32,
  ...rest
}) => {
  const sizeValue = useResponsiveValue(size);
  let src = Component24;

  if (sizeValue === "lg" || sizeValue === "xl") {
    src = Component32;
  }

  return /*#__PURE__*/_jsx(Icon, { ...rest,
    ref: forwardedRef,
    size: sizeValue,
    src: src
  });
};
export const MultiVariantIcon = slot("icon", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerMultiVariantIcon, { ...props,
  forwardedRef: ref
})));
////////
export function createMultiVariantIcon(src24, src32) {
  return slot("icon", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerMultiVariantIcon, { ...props,
    forwardedRef: ref,
    src24: src24,
    src32: src32
  })));
}